// liveStream.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_LIVE_STREAM_DATA,
  MERGE_LIVE_STREAMS_DATA,
  REMOVE_LIVE_STREAM_DATA,
  SET_LIVE_STREAM_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

/*
{
  [id]: {
    id: String,
    session: {
      [sessionId]: {
        karaokePerform: {
          ['pending' | 'completed']: {
            list: [
              {
                "progress": Number,
                "levels": [
                  {
                    "target": Number,
                    "title": String,
                  }
                ],
                "context": {
                  "type": String,
                  "sender_id": String,
                  "streamer_id": String,
                  "device": null | Object,,
                  "product_id": String,
                  "last_updated": Number,
                  "started": Number,
                  "paused": Number
                },
                "exp": Number,
                "id": String
              }
            ],
            page: Number,
            limit: Number
          }
        },
        videoState: {
          [timestamp]: {
            [remoteUserId]: {
              freezeRate: Number,
              totalFreezeTime: Number,
            }
          }
        }
      }
    }
  }
}
*/
export const defaultState = fromJS({});

/**
 * Livestream.
 * @module reducer/liveStream
 */
const liveStream = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_LIVE_STREAM_DATA:
      return _MERGE_LIVE_STREAM_DATA(action.payload)(state);
    case MERGE_LIVE_STREAMS_DATA:
      return _MERGE_LIVE_STREAMS_DATA(action.payload)(state);
    case REMOVE_LIVE_STREAM_DATA:
      return _REMOVE_LIVE_STREAM_DATA(action.payload)(state);
    case SET_LIVE_STREAM_DATA:
      return _SET_LIVE_STREAM_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Merge liveStream data
 * @kind reducer/actionType
 * @name MERGE_LIVE_STREAM_DATA
 * @param {array} {selectPath} - operation data select path
 * @param {any} {data} - operation data
 * @return {Immutable.Map} New state
 */
const _MERGE_LIVE_STREAM_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

/**
 * Merge liveStreams' data
 * @kind reducer/actionType
 * @name MERGE_LIVE_STREAMS_DATA
 * @param {any} {data} - liveStream's data
 * @return {Immutable.Map} New state
 */
const _MERGE_LIVE_STREAMS_DATA =
  ({ data }) =>
  state =>
    state.mergeDeep(data);

/**
 * Remove live stream data
 * @kind reducer/actionType
 * @name REMOVE_LIVE_STREAM_DATA
 * @param {array} {selectPath} - select path
 * @return {Immutable.Map} New state
 */
const _REMOVE_LIVE_STREAM_DATA =
  ({ selectPath }) =>
  state => {
    return state.deleteIn(selectPath);
  };

/**
 * Set live stream data
 * @kind reducer/actionType
 * @name SET_LIVE_STREAM_DATA
 * @param {array} selectPath - been removed data select path
 * @param {any} data - operation data
 * @return {Immutable.Map} New state
 */
const _SET_LIVE_STREAM_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.setIn([...selectPath], fromJS(data));
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default liveStream;
